/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
document.addEventListener('page:loaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const cartItems = urlParams.get('add_to_cart_items');
  if (cartItems) {
    try {
      const jsonString = atob(cartItems);
      const productsToAdd = JSON.parse(jsonString);
      if (productsToAdd.length > 0) {
        window.history.replaceState({}, document.title, window.location.pathname);
        addProductsToCart(productsToAdd);
      }
    } catch (error) {
      console.error('Erreur de décodage Base64:', error);
    }
  }
});
async function addProductsToCart(variantIds) {
  const miniCart = document.querySelector('mini-cart');
  try {
    const items = variantIds.map(id => ({
      id,
      quantity: 1
    }));
    const sections = miniCart ? miniCart.getSectionsToRender().map(section => section.id) : [];
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname
      })
    });
    if (response.ok) {
      const data = await response.json();
      if (data.status === 422) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: data.description
          }
        }));
      } else {
        if (miniCart && typeof miniCart.open === 'function') {
          miniCart.renderContents(data);
          miniCart.open();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data
            }
          }));
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      }
    }
  } catch (error) {
    console.error('Erreur:', error);
  }
}
/******/ })()
;